module.exports = fox._r("images/header-placeholder.png", __webpack_public_path__ + "images/header-placeholder.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/header-placeholder.png
// module id = 1055
// module chunks = 4